/* global Date */

export function now() {
  return new Date();
}
